import React, { useEffect, useState } from "react";

/** Brief logo screen on the first open of a session (not on every navigation). */
export function Splash() {
  const [phase, setPhase] = useState<"show" | "hide" | "done">(() => {
    try {
      return sessionStorage.getItem("kms.splash") ? "done" : "show";
    } catch {
      return "done";
    }
  });
  useEffect(() => {
    if (phase !== "show") return;
    try {
      sessionStorage.setItem("kms.splash", "1");
    } catch {
      /* private mode */
    }
    const t1 = setTimeout(() => setPhase("hide"), 650);
    const t2 = setTimeout(() => setPhase("done"), 1000);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
  }, [phase]);
  if (phase === "done") return null;
  return (
    <div className={`splash ${phase === "hide" ? "splash--hide" : ""}`} aria-hidden="true">
      <img src="/brand/kms-logo.png" alt="" />
    </div>
  );
}
